export const featuresConstants = {
    allFeatures: [
        "ANON_CANVASSING",
        "RECEPTION",
        "EMAIL_BLAST",
        "DELETE_VOTER",
        "EDIT_VOTER",
        "ADD_VOTER",
        "DELETE_HOUSE",
        "ADD_HOUSE",
        "ADD_HOUSE",
        "EDIT_HOUSE",
        "ISSUE",
        "SURVEY",
        "EXPORT",
        "CANVASSER_TRACKING",
        "CANVASSER_TRACKING_ALLOWED",
        "TURF_CUTTING",
        "EDIT_VOTER_NAME",
        "AUTO_GENERATE_VOTER_NAME",
        "HOUSE_NOTES",
        "USERLIMIT",
        "USER_URL",
        "EDIT_CAMPAIGN_NAME",
        "CREATE_EVENT",
        "UPDATE_EVENT",
        "PUBLIC_API",
        "GO_APP",
        "EDIT_BUILDING",
        "DASHBOARDS_PAGE",
        "APPOINTMENTS",
        "EDIT_APPOINTMENTS",
        "DELETE_APPOINTMENTS",
        "USER_INVITE",
        "PROSPECTOR_L2",
        "PROSPECTOR_ALLOWED",
        "APPROVAL_NEEDED",
        "IMPORT_CAMPAIGN_LEVEL",
        "IMPORT_ORGANISATION_LEVEL",
        "CREATE_CUSTOM_FIELD_CAMPAIGN_LEVEL",
        "CREATE_CUSTOM_FIELD_ORGANISATION_LEVEL",
        "APP_STORE",
        "CREATE_TEAM",
        "CREATE_EFFORT",
        "PERMISSIONS",
    ],
    canvasserNotAllowedFeatures: [
        "EMAIL_BLAST",
        "EXPORT",
        "CANVASSER_TRACKING_ALLOWED",
        "USER_URL",
        "EDIT_CAMPAIGN_NAME",
    ],
} as const;
